import { Box, Button, Grid, GridItem, Text } from "@chakra-ui/react"
import React from "react"
import { Colors } from "../../theme/colors"

export const UtilityCollarDocumentation: React.FC = (): JSX.Element => {
  const headerStyles = {
    fontWeight: "bold",
    bg: Colors.Primary.accent,
    px: "2",
    py: "3",
    fontSize: "14px",
    color: "white",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const columnStyles = {
    px: "1px",
    py: "1px",
    bg: "white",
    fontSize: "14px",
    border: "1px solid",
    borderColor: "gray.200",
    textAlign: "left" as const
  }

  const frlStyle = {
    py: "2",
    bg: "white",
    fontSize: "14px",
    border: "0.5px solid",
    borderColor: "gray.200",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const firstColumnStyles = {
    px: "1px",
    py: "1px",
    bg: "white",
    fontSize: "14px",
    border: "0.5px solid",
    borderColor: "gray.200",
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const tableHeadingStyles = {
    mt: "6",
    fontWeight: "bold",
    fontSize: "18px",
    color: Colors.Primary.c1
  }

  return (
    <Box>
      {/* Jump to Navigation Links */}
      <Box mb="6" p="4" borderRadius="md" border="1px solid" borderColor={Colors.Primary.c1} id="quick-navigation">
        <Text fontSize="16px" fontWeight="bold" mb="3" color={Colors.Primary.c1}>
          Quick Navigation
        </Text>
        <Box display="flex" flexWrap="wrap" gap="3">
          <a
            href="#concrete-bondek-slab"
            style={{
              color: Colors.Primary.c1,
              textDecoration: "underline",
              fontSize: "14px",
              padding: "4px 8px",
              borderRadius: "4px",
              backgroundColor: "white",
              border: "1px solid #e2e8f0"
            }}
          >
            Concrete or Bondek Slab
          </a>
          <a
            href="#plasterboard-steel-stud"
            style={{
              color: Colors.Primary.c1,
              textDecoration: "underline",
              fontSize: "14px",
              padding: "4px 8px",
              borderRadius: "4px",
              backgroundColor: "white",
              border: "1px solid #e2e8f0"
            }}
          >
            Plasterboard Lined Steel Stud Walls
          </a>
          <a
            href="#shaft-liner-plasterboard"
            style={{
              color: Colors.Primary.c1,
              textDecoration: "underline",
              fontSize: "14px",
              padding: "4px 8px",
              borderRadius: "4px",
              backgroundColor: "white",
              border: "1px solid #e2e8f0"
            }}
          >
            Shaft Liner/Plasterboard Steel Stud Walls
          </a>
          <a
            href="#hebel-walsc-walls"
            style={{
              color: Colors.Primary.c1,
              textDecoration: "underline",
              fontSize: "14px",
              padding: "4px 8px",
              borderRadius: "4px",
              backgroundColor: "white",
              border: "1px solid #e2e8f0"
            }}
          >
            Hebel or Walsc Walls
          </a>
          <a
            href="#dincel-afs-walls"
            style={{
              color: Colors.Primary.c1,
              textDecoration: "underline",
              fontSize: "14px",
              padding: "4px 8px",
              borderRadius: "4px",
              backgroundColor: "white",
              border: "1px solid #e2e8f0"
            }}
          >
            Dincel Wall, AFS Logicwall or AFS Rediwall
          </a>
          <a
            href="#concrete-masonry-aac"
            style={{
              color: Colors.Primary.c1,
              textDecoration: "underline",
              fontSize: "14px",
              padding: "4px 8px",
              borderRadius: "4px",
              backgroundColor: "white",
              border: "1px solid #e2e8f0"
            }}
          >
            Concrete, Masonry and AAC Block Walls
          </a>
          <a
            href="#speedpanel-walls"
            style={{
              color: Colors.Primary.c1,
              textDecoration: "underline",
              fontSize: "14px",
              padding: "4px 8px",
              borderRadius: "4px",
              backgroundColor: "white",
              border: "1px solid #e2e8f0"
            }}
          >
            Speedpanel Walls
          </a>
        </Box>
      </Box>

      <Text {...tableHeadingStyles} id="concrete-bondek-slab">
        Concrete or Bondek Slab - Stack Applications (see Note)
      </Text>

      {/* PVC Pipes in Concrete or Bondek Slabs Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="1fr 1fr 1fr repeat(3, 1fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={2}>
            Pipe Dia. (nom mm)
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Fitting
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Collar
          </GridItem>
          <GridItem {...headerStyles} colSpan={3}>
            FRL - Slab Thickness
          </GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>≥120mm</Box>
          <Box {...headerStyles}>≥150mm</Box>
          <Box {...headerStyles}>≥175mm</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={6}>
            <b>PVC Pipes in Concrete or Bondek Slabs</b>
          </GridItem>

          {/* Row 1: 40mm No fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 2: 40mm Yes fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 40+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 3: 50mm No fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 4: 50mm Yes fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 5: 65mm No fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 6: 65mm Yes fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 7: 80mm No fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 8: 80mm Yes fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 9: 90mm No fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 10: 90mm Yes fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 90+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 11: 100mm No fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 12: 100mm Yes fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 100+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 13: 150mm No fitting */}
          <Box {...firstColumnStyles}>150</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={6}>
            <b>HDPE Pipes in Concrete or Bondek Slabs</b>
          </GridItem>

          {/* Row 1: 40mm No fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 2: 50mm No fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 3: 56mm No fitting */}
          <Box {...firstColumnStyles}>56</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 4: 63mm No fitting */}
          <Box {...firstColumnStyles}>63</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 5: 75mm No fitting */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 6: 90mm No fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 7: 110mm No fitting */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 8: 125mm No fitting */}
          <Box {...firstColumnStyles}>125</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 125</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 9: 160mm No fitting */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={6}>
            <b>Triplus Pipes in Concrete or Bondek Slabs</b>
          </GridItem>

          {/* Row 1: 40mm Triplus */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 2: 50mm Triplus */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 3: 75mm Triplus */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 4: 90mm Triplus */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 5: 110mm Triplus */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 6: 160mm Triplus */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={6}>
            <b>Raupiano Pipes in Concrete or Bondek Slabs</b>
          </GridItem>

          {/* Row 1: 40mm Raupiano */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 2: 50mm Raupiano */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 3: 75mm Raupiano */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 4: 110mm Raupiano */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>

          {/* Row 5: 160mm Raupiano */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/180/180</Box>
          <Box {...frlStyle}>-/240/240</Box>
        </Grid>
      </Box>

      {/* Notes Section */}
      <Box mt="6" p="4" borderRadius="md" border="1px solid" borderColor={Colors.Primary.c1}>
        <Text fontSize="14px" mb="2" color={Colors.Primary.c1}>
          For sealing around annular gap see sealant details in{" "}
          <a target="_blank" href="/report/FCO3520" style={{ textDecoration: "underline" }}>
            FCO3520
          </a>
        </Text>
        <Text fontSize="14px" color={Colors.Primary.c1}>
          <b>Note:</b> Snap Fire Seal FRAS to fill Bondek channel underneath collar and 20mm beyond collar (Figure 4{" "}
          <a target="_blank" href="/report/FCO3520" style={{ color: Colors.Primary.c1, textDecoration: "underline" }}>
            FCO3520
          </a>
          )
        </Text>
      </Box>

      <Text {...tableHeadingStyles} mt="8" id="plasterboard-steel-stud">
        Plasterboard Lined Steel Stud Walls
      </Text>

      {/* Plasterboard Lined Steel Stud Walls Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="1fr 1fr 1fr repeat(2, 1fr)" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={2}>
            Pipe Dia. (nom)
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Fitting
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Collar
          </GridItem>
          <GridItem {...headerStyles} colSpan={2}>
            FRL - Wall Lining
          </GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>≥1x13mm Sheets</Box>
          <Box {...headerStyles}>≥2x13mm sheets</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5}>
            <b>PVC Pipes in Plasterboard Lined Steel Stud Walls</b>
          </GridItem>

          {/* Row 1: 40mm No fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 40mm Yes fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 40+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 50mm No fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 50mm Yes fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 65mm No fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 65mm Yes fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 7: 80mm No fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 80mm Yes fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 9: 90mm No fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 10: 90mm Yes fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 90+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 11: 100mm No fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 12: 100mm Yes fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 100+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 13: 150mm No fitting */}
          <Box {...firstColumnStyles}>150</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5}>
            <b>HDPE Pipes in Plasterboard Lined Steel Stud Walls</b>
          </GridItem>

          {/* Row 1: 40mm HDPE */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm HDPE */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 56mm HDPE */}
          <Box {...firstColumnStyles}>56</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 63mm HDPE */}
          <Box {...firstColumnStyles}>63</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 75mm HDPE */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 90mm HDPE */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 7: 110mm HDPE */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 125mm HDPE */}
          <Box {...firstColumnStyles}>125</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 125</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/120/90</Box>

          {/* Row 9: 160mm HDPE */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>N/A</Box>
          <Box {...frlStyle}>-/120/90</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5}>
            <b>Triplus Pipes in Plasterboard Lined Steel Stud Walls</b>
          </GridItem>

          {/* Row 1: 40mm Triplus */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Triplus */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Triplus */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 90mm Triplus */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 110mm Triplus */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 160mm Triplus */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5}>
            <b>Raupiano Pipes in Plasterboard Lined Steel Stud Walls</b>
          </GridItem>

          {/* Row 1: 40mm Raupiano */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Raupiano */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Raupiano */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 110mm Raupiano */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 160mm Raupiano */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5} textAlign={"left" as const}>
            For sealing around annular gap see sealant details in&nbsp;
            <a target="_blank" href="/report/FCO3520" style={{ textDecoration: "underline" }}>
              FCO3520
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8" id="shaft-liner-plasterboard">
        Shaft Liner/Plasterboard Steel Stud Walls
      </Text>

      {/* Shaft Liner/Plasterboard Steel Stud Walls Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="1fr 1fr 1fr 2fr" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={2}>
            Pipe Dia. (nom)
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Fitting
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Collar
          </GridItem>
          <GridItem {...headerStyles}>FRL</GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>
            ≥2x13mm sheets side one <br /> ≥25mm shaft liner side two
          </Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={4}>
            <b>PVC Pipes in Shaft Liner/Plasterboard Steel Stud Walls</b>
          </GridItem>

          {/* Row 1: 40mm No fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 40mm Yes fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 40+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 50mm No fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 50mm Yes fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 65mm No fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 65mm Yes fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 7: 80mm No fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 80mm Yes fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 9: 90mm No fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 10: 90mm Yes fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 90+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 11: 100mm No fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 12: 100mm Yes fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 100+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 13: 150mm No fitting */}
          <Box {...firstColumnStyles}>150</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/120/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={4}>
            <b>HDPE Pipes in Shaft Liner/Plasterboard Steel Stud Walls</b>
          </GridItem>

          {/* Row 1: 40mm HDPE */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm HDPE */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 56mm HDPE */}
          <Box {...firstColumnStyles}>56</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 63mm HDPE */}
          <Box {...firstColumnStyles}>63</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 75mm HDPE */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 90mm HDPE */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 7: 110mm HDPE */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 125mm HDPE */}
          <Box {...firstColumnStyles}>125</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 125</Box>
          <Box {...frlStyle}>-/120/90</Box>

          {/* Row 9: 160mm HDPE */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/120/90</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={4}>
            <b>Triplus Pipes in Shaft Liner/Plasterboard Steel Stud Walls</b>
          </GridItem>

          {/* Row 1: 40mm Triplus */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Triplus */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Triplus */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 90mm Triplus */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 110mm Triplus */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 160mm Triplus */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/120/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={4}>
            <b>Raupiano Pipes in Shaft Liner/Plasterboard Steel Stud Walls</b>
          </GridItem>

          {/* Row 1: 40mm Raupiano */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Raupiano */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Raupiano */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 110mm Raupiano */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 160mm Raupiano */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={4} textAlign={"left" as const}>
            For sealing around annular gap see sealant details in{" "}
            <a target="_blank" href="/report/FCO3520" style={{ textDecoration: "underline" }}>
              FCO3520
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8" id="hebel-walsc-walls">
        Hebel or Walsc Walls
      </Text>

      {/* Hebel or Walsc Walls Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="1fr 1fr 1fr 1fr 1fr" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={2}>
            Pipe Dia. (nom)
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Fitting
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Collar
          </GridItem>
          <GridItem {...headerStyles} colSpan={2}>
            FRL - AAC panel
          </GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>75mm Hebel or Walsc (single mesh)</Box>
          <Box {...headerStyles}>75mm Hebel (caged mesh)</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5}>
            <b>PVC Pipes in Hebel or Walsc Walls</b>
          </GridItem>

          {/* Row 1: 40mm No fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 40mm Yes fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 40+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 50mm No fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 50mm Yes fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 65mm No fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 65mm Yes fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 7: 80mm No fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 80mm Yes fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 9: 90mm No fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 10: 90mm Yes fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 90+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 11: 100mm No fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 12: 100mm Yes fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 100+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 13: 150mm No fitting */}
          <Box {...firstColumnStyles}>150</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/90</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5}>
            <b>HDPE Pipes in Hebel or Walsc Walls</b>
          </GridItem>

          {/* Row 1: 40mm HDPE */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm HDPE */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 56mm HDPE */}
          <Box {...firstColumnStyles}>56</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 63mm HDPE */}
          <Box {...firstColumnStyles}>63</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 75mm HDPE */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 90mm HDPE */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 7: 110mm HDPE */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 125mm HDPE */}
          <Box {...firstColumnStyles}>125</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 125</Box>
          <Box {...frlStyle}>-/90/60</Box>
          <Box {...frlStyle}>-/120/90</Box>

          {/* Row 9: 160mm HDPE */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/90/60</Box>
          <Box {...frlStyle}>-/120/90</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5}>
            <b>Triplus Pipes in Hebel or Walsc Walls</b>
          </GridItem>

          {/* Row 1: 40mm Triplus */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Triplus */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Triplus */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 90mm Triplus */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 110mm Triplus */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 160mm Triplus */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5}>
            <b>Raupiano Pipes in Hebel or Walsc Walls</b>
          </GridItem>

          {/* Row 1: 40mm Raupiano */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Raupiano */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Raupiano */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 110mm Raupiano */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 160mm Raupiano */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={5} textAlign={"left" as const}>
            For sealing around annular gap see sealant details in{" "}
            <a target="_blank" href="/report/FCO3520" style={{ textDecoration: "underline" }}>
              FCO3520
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8" id="dincel-afs-walls">
        Dincel Wall, AFS Logicwall or AFS Rediwall (see Note)
      </Text>

      {/* Dincel Wall, AFS Logicwall or AFS Rediwall Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="1fr 1fr 2fr 1fr 1fr 1fr 1fr" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={2}>
            Pipe Dia. (nom)
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Fitting
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Collar
          </GridItem>
          <GridItem {...headerStyles} colSpan={4}>
            FRL - Wall Type
          </GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>110mm Dincel</Box>
          <Box {...headerStyles}>110mm Rediwall</Box>
          <Box {...headerStyles}>120mm Logicwall LW120</Box>
          <Box {...headerStyles}>155mm Dincel</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7}>
            <b>PVC Pipes in Dincel Wall, AFS Logicwall or AFS Rediwall</b>
          </GridItem>

          {/* Row 1: 40mm No fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 2: 40mm Yes fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 40+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 3: 50mm No fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 4: 50mm Yes fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 5: 65mm No fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 6: 65mm Yes fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 7: 80mm No fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 8: 80mm Yes fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 9: 90mm No fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 10: 90mm Yes fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 90+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 11: 100mm No fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 12: 100mm Yes fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 100+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 13: 150mm No fitting */}
          <Box {...firstColumnStyles}>150</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7}>
            <b>HDPE Pipes in Dincel Wall, AFS Logicwall or AFS Rediwall</b>
          </GridItem>

          {/* Row 1: 40mm HDPE */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 2: 50mm HDPE */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 3: 56mm HDPE */}
          <Box {...firstColumnStyles}>56</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 4: 63mm HDPE */}
          <Box {...firstColumnStyles}>63</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 5: 75mm HDPE */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 6: 90mm HDPE */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 7: 110mm HDPE */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 8: 125mm HDPE */}
          <Box {...firstColumnStyles}>125</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 125</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/90</Box>
          <Box {...frlStyle}>-/180/90</Box>

          {/* Row 9: 160mm HDPE */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/90</Box>
          <Box {...frlStyle}>-/180/90</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7}>
            <b>Triplus Pipes in Dincel Wall, AFS Logicwall or AFS Rediwall</b>
          </GridItem>

          {/* Row 1: 40mm Triplus */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Row 2: 50mm Triplus */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Row 3: 75mm Triplus */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Row 4: 90mm Triplus */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Row 5: 110mm Triplus */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/120</Box>

          {/* Row 6: 160mm Triplus */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7}>
            <b>Raupiano Pipes in Dincel Wall, AFS Logicwall or AFS Rediwall</b>
          </GridItem>

          {/* Row 1: 40mm Raupiano */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 2: 50mm Raupiano */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 3: 75mm Raupiano */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 4: 110mm Raupiano */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 5: 160mm Raupiano */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/180/180</Box>
        </Grid>
      </Box>

      {/* Notes Section */}
      <Box mt="6" p="4" borderRadius="md" border="1px solid" borderColor={Colors.Primary.c1}>
        <Text fontSize="14px" mb="2" color={Colors.Primary.c1}>
          For sealing around annular gap see sealant details in{" "}
          <a target="_blank" href="/report/FCO3520" style={{ textDecoration: "underline" }}>
            FCO3520
          </a>
        </Text>
        <Text fontSize="14px" color={Colors.Primary.c1}>
          <b>Note:</b> Fixings to be away from void with a minimum of 25mm embedment into concrete part of the wall.
        </Text>
      </Box>

      <Text {...tableHeadingStyles} mt="8" id="concrete-masonry-aac">
        Concrete, Masonry and AAC Block Walls
      </Text>

      {/* Concrete, Masonry and AAC Block Walls Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="1fr 1fr 1fr 1fr 1fr 1fr 1fr" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={3}>
            Pipe Dia. (nom)
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Fitting
          </GridItem>
          <GridItem {...headerStyles} rowSpan={3}>
            Collar
          </GridItem>
          <GridItem {...headerStyles} colSpan={4}>
            FRL
          </GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>Concrete Wall</Box>
          <Box {...headerStyles}>Masonry wall or AAC block wall</Box>
          <Box {...headerStyles}>Concrete wall or AAC block wall</Box>
          <Box {...headerStyles}>Masonry wall</Box>

          <Box {...headerStyles}>Min 80mm</Box>
          <Box {...headerStyles}>Min 90mm</Box>
          <Box {...headerStyles}>Min 120mm</Box>
          <Box {...headerStyles}>Min 130mm</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7}>
            <b>PVC Pipes in Concrete, Masonry and AAC Block Walls</b>
          </GridItem>

          {/* Row 1: 40mm No fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 40mm Yes fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 40+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 3: 50mm No fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 50mm Yes fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 5: 65mm No fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 65mm Yes fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 7: 80mm No fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 80mm Yes fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 9: 90mm No fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 10: 90mm Yes fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 90+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 11: 100mm No fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 12: 100mm Yes fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 100+</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/180/180</Box>

          {/* Row 13: 150mm No fitting */}
          <Box {...firstColumnStyles}>150</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7}>
            <b>HDPE Pipes in Concrete, Masonry and AAC Block Walls</b>
          </GridItem>

          {/* Row 1: 40mm HDPE */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm HDPE */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 56mm HDPE */}
          <Box {...firstColumnStyles}>56</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 63mm HDPE */}
          <Box {...firstColumnStyles}>63</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 75mm HDPE */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 90mm HDPE */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 7: 110mm HDPE */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 125mm HDPE */}
          <Box {...firstColumnStyles}>125</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 125</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/90</Box>
          <Box {...frlStyle}>-/120/90</Box>

          {/* Row 9: 160mm HDPE */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/90</Box>
          <Box {...frlStyle}>-/120/90</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7}>
            <b>Triplus Pipes in Concrete, Masonry and AAC Block Walls</b>
          </GridItem>

          {/* Row 1: 40mm Triplus */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Triplus */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Triplus */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 90mm Triplus */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 110mm Triplus */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 160mm Triplus */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7}>
            <b>Raupiano Pipes in Concrete, Masonry and AAC Block Walls</b>
          </GridItem>

          {/* Row 1: 40mm Raupiano */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Raupiano */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Raupiano */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 110mm Raupiano */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 160mm Raupiano */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/120/120</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Footer Note */}
          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={7} textAlign={"left" as const}>
            For sealing around annular gap see sealant details in{" "}
            <a target="_blank" href="/report/FCO3520" style={{ textDecoration: "underline" }}>
              FCO3520
            </a>
          </GridItem>
        </Grid>
      </Box>

      <Text {...tableHeadingStyles} mt="8" id="speedpanel-walls">
        Speedpanel walls (see Note)
      </Text>

      {/* Speedpanel walls Table */}
      <Box mt="4" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        <Grid templateColumns="1fr 1fr 1fr 1fr 1fr 1fr" bg="gray.200" gap="1px">
          {/* Main Headers */}
          <GridItem {...headerStyles} rowSpan={2}>
            Pipe Dia. (nom)
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Fitting
          </GridItem>
          <GridItem {...headerStyles} rowSpan={2}>
            Collar
          </GridItem>
          <GridItem {...headerStyles} colSpan={3}>
            FRL - Plasterboard Patching
          </GridItem>

          {/* FRL Sub-headers */}
          <Box {...headerStyles}>1 x min. 13mm FR</Box>
          <Box {...headerStyles}>1 x min. 16mm FR</Box>
          <Box {...headerStyles}>2 x min. 13mm FR</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={6}>
            <b>PVC Pipes in Speedpanel walls</b>
          </GridItem>

          {/* Row 1: 40mm No fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 40mm Yes fitting */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 40+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 50mm No fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 50mm Yes fitting */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 65mm No fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 65mm Yes fitting */}
          <Box {...firstColumnStyles}>65</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 7: 80mm No fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 80mm Yes fitting */}
          <Box {...firstColumnStyles}>80</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 9: 90mm No fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 10: 90mm Yes fitting */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 90+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 11: 100mm No fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 12: 100mm Yes fitting */}
          <Box {...firstColumnStyles}>100</Box>
          <Box {...firstColumnStyles}>Yes</Box>
          <Box {...firstColumnStyles}>Utility 100+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 13: 150mm No fitting */}
          <Box {...firstColumnStyles}>150</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={6}>
            <b>HDPE Pipes in Speedpanel walls</b>
          </GridItem>

          {/* Row 1: 40mm HDPE */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm HDPE */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 56mm HDPE */}
          <Box {...firstColumnStyles}>56</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 63mm HDPE */}
          <Box {...firstColumnStyles}>63</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 75mm HDPE */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 90mm HDPE */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 7: 110mm HDPE */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 8: 125mm HDPE */}
          <Box {...firstColumnStyles}>125</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 125</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/90</Box>

          {/* Row 9: 160mm HDPE */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/90</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={6}>
            <b>Triplus Pipes in Speedpanel walls</b>
          </GridItem>

          {/* Row 1: 40mm Triplus */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Triplus */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Triplus */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 90mm Triplus */}
          <Box {...firstColumnStyles}>90</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 80+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 110mm Triplus */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 6: 160mm Triplus */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          <GridItem {...columnStyles} color={Colors.Primary.c1} colSpan={6}>
            <b>Raupiano Pipes in Speedpanel walls</b>
          </GridItem>

          {/* Row 1: 40mm Raupiano */}
          <Box {...firstColumnStyles}>40</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 40</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 2: 50mm Raupiano */}
          <Box {...firstColumnStyles}>50</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 50</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 3: 75mm Raupiano */}
          <Box {...firstColumnStyles}>75</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 65+</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 4: 110mm Raupiano */}
          <Box {...firstColumnStyles}>110</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 100</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>

          {/* Row 5: 160mm Raupiano */}
          <Box {...firstColumnStyles}>160</Box>
          <Box {...firstColumnStyles}>No</Box>
          <Box {...firstColumnStyles}>Utility 150</Box>
          <Box {...frlStyle}>-/60/60</Box>
          <Box {...frlStyle}>-/90/90</Box>
          <Box {...frlStyle}>-/120/120</Box>
        </Grid>
      </Box>

      {/* Notes Section */}
      <Box mt="6" p="4" borderRadius="md" border="1px solid" borderColor={Colors.Primary.c1}>
        <Text fontSize="14px" mb="2" color={Colors.Primary.c1}>
          For sealing around annular gap see sealant details in{" "}
          <a target="_blank" href="/report/FCO3520" style={{ textDecoration: "underline" }}>
            FCO3520
          </a>
        </Text>
        <Text fontSize="14px" color={Colors.Primary.c1}>
          <b>Note:</b> Patching to be 250mm x 250mm plasterboard fixed to wall with 14g-10 65mm Hex-head screws at max 100mm centres
        </Text>
      </Box>

      {/* Go to Top Button */}
      <Box position="fixed" bottom="20px" right="20px" zIndex="1000">
        <Button
          onClick={() => {
            document.getElementById("quick-navigation")?.scrollIntoView({
              behavior: "smooth"
            })
          }}
          bg={Colors.Primary.c1}
          color="white"
          borderRadius="50%"
          width="50px"
          height="50px"
          minW="50px"
          fontSize="18px"
          fontWeight="bold"
          _hover={{
            bg: Colors.Primary.accent,
            transform: "scale(1.1)"
          }}
          _active={{
            transform: "scale(0.95)"
          }}
          transition="all 0.2s ease"
          boxShadow="0 4px 12px rgba(0, 0, 0, 0.15)"
          aria-label="Go to top"
        >
          ↑
        </Button>
      </Box>
    </Box>
  )
}
